import { useAccount } from '@/hooks/useAccount';

export const useForestLayoutSelections = () => {
  const { user } = useAccount();

  const bodyShape = user?.onboarding_data?.body_shape || 'athletic';
  const gender = user?.onboarding_data?.gender || 'female';

  return {
    bodyShape,
    gender,
  };
};
